import React, {useContext, useEffect, useState} from 'react';
import {Field, FieldArray, useFormikContext} from "formik";
import useStyles from "../styles";
import {Button, Grid, Typography} from "@material-ui/core";
import InputField from "../../../../FormikUtils/InputField";
import SlantedField from "../../../../FormikUtils/SlantedField";
import SelectField from "../../../../FormikUtils/SelectField";
import RegularInputField from "../../../../../RegularInputField";
import Divider from "@material-ui/core/Divider";
import ClearIcon from "@material-ui/icons/Clear";
import FormikAutocomplete from "../../../../FormikUtils/FormikAutocomplete";
import CotizarContext from "../../../../../../context/CotizarContext";
import Loading from "../../../../../Loading";

export default function ConfirmarForm(props) {

    const classes = useStyles();
    const {
        formField: {
            //POLIZA
            fechaEmision,
            frecuenciaPago,
            vigenciaDesde,
            vigenciaHasta,
            formaDePago,
            moduloCobertura,
            numeroTramite,
            numeroPoliza,
            numeroReferencia,
            premium,
            //CLIENTE
            cliente: {
                sexo,
                fechaNacimiento,
                dni,
                cuit,
                telefono,
                codigoArea,
                domicilio,
                apellido,
                codigosLocalidad,
                email,
                nombre,
                situacionIva
            },
            //VEHICULO
            outStandardSancor,
            vehiculo: {
                patente,
                chasis,
                motor,
                gnc: {
                    valorTotal,
                    cilindros: {
                        marcaCilindro,
                        numeroCilindro
                    },
                    marcaRegulador,
                    numeroRegulador,
                },
                tieneGnc,
            },
            bienesAsegurados: {
                id,
                descripcion,
                suma,
            },
        }
    } = props;
    const {values, setFieldValue} = useFormikContext();
    const {localidades, autosModulos} = useContext(CotizarContext)
    const [optionsModulos, setOptionsModulos] = useState(null);

    const frecuencias = [
        {value: '5', label: 'Anual'}
    ];

    const formasDePago = [
        {value: '0', label: 'Efectivo'},
        {value: '4', label: 'Débito por CBU'},
        {value: '2', label: 'Tarjeta de crédito'}
    ];

    const opcionesSexo = [
        {value: '1', label: 'Femenino'},
        {value: '2', label: 'Masculino'}
    ];

    const opcionesSituacionIva = [
        {value: '1', label: 'Responsable Inscripto'},
        {value: '4', label: 'Consumidor Final'},
    ];

    const booleans = [
        {value: '1', label: 'Si'},
        {value: '0', label: 'No'},
    ];

    const fueraPautaOptions = [
        {value: 'true', label: 'Si'},
        {value: 'false', label: 'No'},
    ];

    const cilindroVacio = {
        [marcaCilindro.name]: '',
        [numeroCilindro.name]: '',
    };

    const bienVacio = {
        [id.name]: '10',
        [descripcion.name]: '',
        [suma.name]: '',
    };


    function CuitGenerator(dni, gender) {
        if (!dni || dni.length !== 8) {
            throw new Error('El número DNI debe contener 8 números ');
        }

        let genderNumber = gender === '2' ? 20 : 27;

        const generateverificator = () => {
            const multipliers = [2, 3, 4, 5, 6, 7];
            const genderNumberAndDNI = `${genderNumber}${dni}`;

            let total = 0;
            let multpIndex = 0;
            for (let i = String(genderNumberAndDNI).length - 1; i > -1; i--) {
                const sum = genderNumberAndDNI[i] * multipliers[multpIndex];
                total += sum;
                if (multpIndex === 5) multpIndex = 0;
                else multpIndex += 1;
            }

            const verificator = 11 - (total % 11);
            if (verificator === 10) {
                genderNumber = 23;
                return generateverificator();
            }
            if (verificator === 11) return 0;
            return verificator;
        };
        const verificator = generateverificator();

        return `${genderNumber}${dni}${verificator}`
    }

    function add_years(dt) {
        let date = new Date(dt.setYear(dt.getFullYear() + 1));
        const offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset * 60 * 1000))
        date = date.toISOString().split('T')[0]
        return date
    }

    useEffect(() => {
        if ((values.clientes[0].dni).length === 8 && values.clientes[0].sexo !== '') {
            let cuit = CuitGenerator(values.clientes[0].dni, values.clientes[0].sexo)
            setFieldValue('clientes[0].cuit', cuit)
        }
    }, [values.clientes[0].dni, values.clientes[0].sexo]);

    useEffect(() => {
        let array = []
        autosModulos.map(modulo => {
            array.push({
                value: modulo.idModulo,
                label: modulo.NombreModulo
            })
        })
        setOptionsModulos(array)
    }, []);

    useEffect(() => {
        let date;
        if (new Date(values.vigenciaDesde.replace(/-/g, '/')) > new Date().getDate() - 1) {
            date = new Date(values.vigenciaDesde.replace(/-/g, '/'));
            setFieldValue("vigenciaHasta", add_years(date).toString())
        }
    }, [values.vigenciaDesde])


    if (!optionsModulos) return <Loading/>;
    return (
        <React.Fragment>
            <Grid item xs={12} style={{margin: "16px 0"}}>
                <Typography variant="h5" gutterBottom style={{fontFamily: 'Nunito', color: "#BB0D66"}}>
                    Información referida a la póliza:
                </Typography>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <InputField
                        name={fechaEmision.name}
                        label={fechaEmision.label}
                        type="date"
                        fullWidth
                        textTransform={'uppercase'}
                        InputLabelProps={{shrink: true,}}
                    />
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Grid item xs={12} sm={7}>
                        <SelectField
                            name={frecuenciaPago.name}
                            label={frecuenciaPago.label}
                            data={frecuencias}
                            disabled
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputField
                        name={vigenciaDesde.name}
                        label={vigenciaDesde.label}
                        type="date"
                        fullWidth
                        textTransform={'uppercase'}
                        InputLabelProps={{shrink: true,}}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SlantedField value={values.vigenciaHasta.split('-').reverse().join('/')}
                                  label={vigenciaHasta.label}/>
                </Grid>

                <Grid item xs={12}>
                    <Divider variant="middle"/>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={formaDePago.name}
                        label={formaDePago.label}
                        data={formasDePago}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputField
                        name={premium.name}
                        label={premium.label}
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <SelectField
                        name={moduloCobertura.name}
                        label={moduloCobertura.label}
                        data={optionsModulos}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider variant="middle"/>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputField
                        name={numeroReferencia.name}
                        label={numeroReferencia.label}
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>


                <Grid item xs={12} sm={4}>
                    <InputField
                        name={numeroPoliza.name}
                        label={numeroPoliza.label}
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputField
                        name={numeroTramite.name}
                        label={numeroTramite.label}
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>

            </Grid>

            <Grid item xs={12} style={{marginTop: "32px"}}>
                <Typography variant="h5" gutterBottom style={{fontFamily: 'Nunito', color: "#BB0D66"}}>
                    Información referida al cliente:
                </Typography>
            </Grid>

            <Grid container spacing={3}>

                <Grid item xs={12} sm={6}>
                    <InputField
                        name={`clientes[0]${nombre.name}`}
                        label={nombre.label}
                        textTransform={'capitalize'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={`clientes[0]${apellido.name}`}
                        label={apellido.label}
                        textTransform={'capitalize'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={`clientes[0]${sexo.name}`}
                        label={sexo.label}
                        data={opcionesSexo}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={`clientes[0]${dni.name}`}
                        label={dni.label}
                        textTransform={'uppercase'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <RegularInputField
                        name={`clientes[0]${cuit.name}`}
                        value={`${values.clientes[0].cuit}`}
                        label={cuit.label}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={`clientes[0]${fechaNacimiento.name}`}
                        label={fechaNacimiento.label}
                        type="date"
                        fullWidth
                        textTransform={'lowercase'}
                        InputLabelProps={{shrink: true,}}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={`clientes[0]${codigoArea.name}`}
                        label={codigoArea.label}
                        textTransform={'uppercase'}
                        placeholder={"Sin el 0"}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={`clientes[0]${telefono.name}`}
                        label={telefono.label}
                        placeholder={"Sin el 15"}
                        textTransform={'uppercase'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <InputField
                        name={`clientes[0]${email.name}`}
                        label={email.label}
                        textTransform={'lowercase'}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Field
                        name={`clientes[0]${codigosLocalidad.name}`}
                        label={codigosLocalidad.label}
                        component={FormikAutocomplete}
                        options={localidades}
                        textFieldProps={{
                            label: codigosLocalidad.label,
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={`clientes[0]${domicilio.name}`}
                        label={domicilio.label}
                        textTransform={'capitalize'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={`clientes[0]${situacionIva.name}`}
                        label={situacionIva.label}
                        data={opcionesSituacionIva}
                        fullWidth
                    />
                </Grid>
            </Grid>


            <Grid item xs={12} style={{marginTop: "32px"}}>
                <Typography variant="h5" gutterBottom style={{fontFamily: 'Nunito', color: "#BB0D66"}}>
                    Información referida al vehículo:
                </Typography>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <InputField
                        name={`vehiculo.${patente.name}`}
                        label={patente.label}
                        fullWidth
                        textTransform={'uppercase'}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputField
                        name={`vehiculo.${motor.name}`}
                        label={motor.label}
                        textTransform={'uppercase'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputField
                        name={`vehiculo.${chasis.name}`}
                        label={chasis.label}
                        textTransform={'uppercase'}
                        fullWidth
                    />
                </Grid>


                <Grid item xs={12} sm={4}>
                    <SelectField
                        name={`vehiculo.${tieneGnc.name}`}
                        value={`${values.vehiculo.tieneGnc}`}
                        label={tieneGnc.label}
                        data={booleans}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <SelectField
                        name={outStandardSancor.name}
                        label={outStandardSancor.label}
                        data={fueraPautaOptions}
                        fullWidth
                    />
                </Grid>
                {values.vehiculo.tieneGnc === '1' && (
                    <Grid item container spacing={3}>
                        <Grid item xs={12}>
                            <Divider variant="middle"/>
                        </Grid>
                        <Grid item xs={12}>
                            <p className={classes.subtitleStyle}>Datos del equipo GNC</p>
                        </Grid>
                        <Grid item xs={4}>
                            <InputField
                                textTransform={'capitalize'}
                                name={`vehiculo.gnc.${marcaRegulador.name}`}
                                label={marcaRegulador.label}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <InputField
                                name={`vehiculo.gnc.${numeroRegulador.name}`}
                                label={numeroRegulador.label}
                                fullWidth
                                textTransform={'uppercase'}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <InputField
                                name={`vehiculo.gnc.${valorTotal.name}`}
                                label={valorTotal.label}
                                fullWidth
                                textTransform={'uppercase'}
                            />
                        </Grid>
                        <FieldArray name='vehiculo.gnc.cilindros'>{({remove}) => (
                            values.vehiculo.gnc.cilindros.map((e, index) => (
                                <Grid item container spacing={2} className={classes.listRow}>
                                    <Grid item xs={4}>
                                        <InputField
                                            textTransform={'capitalize'}
                                            name={`vehiculo.gnc.cilindros[${index}].${marcaCilindro.name}`}
                                            label={marcaCilindro.label}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <InputField
                                            name={`vehiculo.gnc.cilindros[${index}].${numeroCilindro.name}`}
                                            label={numeroCilindro.label}
                                            textTransform={'uppercase'}
                                            fullWidth
                                        />
                                    </Grid>
                                    {values.vehiculo.gnc.cilindros.length !== 1 && (
                                        <Grid item xs={4}>
                                            <Button onClick={() => remove(index)}><ClearIcon/></Button>
                                        </Grid>
                                    )}
                                </Grid>
                            ))
                        )}</FieldArray>
                        {values.vehiculo.gnc.cilindros.length < 4 && (
                            <Grid item xs={12}>
                                <FieldArray name='vehiculo.gnc.cilindros'>{({push}) => (
                                    <Button variant='outlined' className={classes.buttonForm2}
                                            onClick={() => push(cilindroVacio)}>Nuevo
                                        Cilindro</Button>
                                )}</FieldArray>
                            </Grid>
                        )}
                    </Grid>
                )}
                <Grid item xs={12}>
                    <p className={classes.subtitleStyle}>Bienes asegurados (Adicionales)</p>
                </Grid>
                <FieldArray name='bienesAsegurados'>{({remove}) => (
                    values.bienesAsegurados.map((e, index) => (
                        <Grid item container spacing={2} className={classes.listRow}>
                            <Grid item xs={4}>
                                <InputField
                                    name={`bienesAsegurados[${index}].${descripcion.name}`}
                                    label={descripcion.label}
                                    textTransform={'capitalize'}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <InputField
                                    name={`bienesAsegurados[${index}].${suma.name}`}
                                    label={suma.label}
                                    textTransform={'uppercase'}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Button onClick={() => remove(index)} style={{marginTop: "16px"}}><ClearIcon/></Button>
                            </Grid>
                        </Grid>
                    ))
                )}</FieldArray>
                <Grid item xs={12}>
                    <FieldArray name='bienesAsegurados'>{({push}) => (
                        <Button variant='outlined' className={classes.buttonForm2} onClick={() => push(bienVacio)}>Agregar
                            bien adicional</Button>
                    )}</FieldArray>
                </Grid>
            </Grid>

        </React.Fragment>
    );
}
